import { ScanBarcode } from 'lucide-react';
import { type SyntheticEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from './ui/button';
import { Input } from './ui/input';

export interface ScannedLine {
  code: string;
  qty: number;
}

/**
 * Поле для сканера штрихкодов: сканер «печатает» код и нажимает Enter. Каждый скан
 * добавляет одну штуку; код можно ввести и руками.
 */
export function ScanInput({
  onScan,
  autoFocus = true,
  label,
}: {
  onScan: (code: string) => void;
  autoFocus?: boolean;
  label?: string;
}) {
  const { t } = useTranslation();
  const [code, setCode] = useState('');
  const submit = (e: SyntheticEvent) => {
    e.preventDefault();
    const value = code.trim();
    if (!value) return;
    onScan(value);
    setCode('');
  };
  return (
    <form onSubmit={submit} className="flex gap-2">
      <Input
        aria-label={label ?? t('wh.scan')}
        placeholder={label ?? t('wh.scan')}
        value={code}
        onChange={(e) => {
          setCode(e.target.value);
        }}
        autoFocus={autoFocus}
        className="font-mono"
      />
      <Button type="submit" variant="outline">
        <ScanBarcode />
        {t('wh.add')}
      </Button>
    </form>
  );
}

/** Добавить скан к списку: тот же код увеличивает количество. */
export function addScan(lines: ScannedLine[], code: string, qty = 1): ScannedLine[] {
  const existing = lines.find((l) => l.code === code);
  if (existing) return lines.map((l) => (l === existing ? { ...l, qty: l.qty + qty } : l));
  return [...lines, { code, qty }];
}
